import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropClosedSupportRequests } from '~/navigation/Navigation.types';

import { SupportRequestItem } from '../SupportRequestItem';
import { SupportRequestList, SupportRequestListNative } from './SupportRequest.List';

export const ClosedSupportRequestsScreen = (props: ScreenPropClosedSupportRequests) => {
  return (
    <PageContainer>
      <ClosedSupportRequestsLayout {...props} />
    </PageContainer>
  );
};

export const ClosedSupportRequestsLayout = (props: ScreenPropClosedSupportRequests) => {
  const supportRequestId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(supportRequestId);
  }, [supportRequestId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <SupportRequestList onPress={(item) => setId(item.id)} id={id} />
      ) : (
        <SupportRequestListNative />
      )}

      {id ? (
        <SupportRequestItem
          originScreen="ClosedSupportRequests"
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
